import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { dangNhapGoogle, theoDoiDangNhap } from "../lib/auth.js";
import { layDb } from "../lib/firebase.js";
import {
  docTatCaYeuCau, docBanNhapAI, yeuCauChayAI, luuBanBienTap, guiKetQua, datTrangThai,
  linkXemDeck, docGocNhin, luuGocNhin, docHinh, yeuCauDungHinh,
} from "../lib/nhanXetDeck.js";
import { TRANG_THAI, MUC_DO, DANH_GIA_SLIDE, MUC_UU_TIEN, TIEU_CHI, KET_QUA_TIEU_CHI, KET_QUA_SUA, chuanHoaNhanXet, banChoFounder, cacLuot, luotTruocCoKetQua } from "@shared/nhanXetDeck.js";
import { diemTrenSlide } from "@shared/viTriChu.js";
import KetQuaNhanXet from "../components/KetQuaNhanXet.jsx";
import SlideChuThich, { useAnhSlide } from "../components/SlideChuThich.jsx";
import { MUC_PHAT_HIEN } from "@shared/kiemTraDeck.js";

/**
 * /admin/nhan-xet-deck: hàng chờ deck founder gửi, bản nháp AI và chỗ biên tập.
 *
 * Từ 27/10/2026 AI tự nhận xét và tự gửi founder (Cloud Function). Trang này
 * để theo dõi chất lượng: sửa bản đã gửi rồi bấm "Gửi lại bản đã sửa", hoặc
 * chạy AI và gửi tay cho deck bị lỗi.
 */

const NHAN_AI = {
  requested: "Đang xếp hàng", running: "AI đang đọc deck", xong: "Bản nháp sẵn sàng",
  loi: "AI gặp lỗi", cho_duyet: "Vượt hạn mức, AI chưa chạy", vuot_han_muc: "Vượt hạn mức tuần, đã báo founder",
};
const ngayGio = (d) => (d ? d.toLocaleString("vi-VN", { dateStyle: "short", timeStyle: "short" }) : "");
const dong = (arr) => (arr || []).join("\n");
const tachDong = (s) => String(s || "").split("\n").map((x) => x.trim()).filter(Boolean);
const TRONG = chuanHoaNhanXet({});

function DanhSach({ ds, dangChon, onChon, loc, setLoc }) {
  const hien = ds.filter((y) => loc === "tat-ca" || (loc === "can-lam" ? ["moi", "dang_xem"].includes(y.status) : y.status === loc));
  return (
    <aside className="surface nx-ds">
      <div className="hang-nut">
        <select value={loc} onChange={(e) => setLoc(e.target.value)} aria-label="Lọc trạng thái">
          <option value="can-lam">Cần làm</option>
          {Object.entries(TRANG_THAI).map(([k, v]) => <option key={k} value={k}>{v.nhan}</option>)}
          <option value="tat-ca">Tất cả</option>
        </select>
        <span className="nho">{hien.length} deck</span>
      </div>
      <ul>
        {hien.map((y) => (
          <li key={y.id} className={y.id === dangChon ? "dang-chon" : ""}>
            <button type="button" className="text-button" onClick={() => onChon(y.id)}>
              <strong>{y.congTy}</strong><br />
              <span className="nho">{ngayGio(y.createdAt)}, {TRANG_THAI[y.status]?.nhan}</span>
            </button>
          </li>
        ))}
      </ul>
    </aside>
  );
}

function SuaDanhSach({ items, mau, onChange, render, them }) {
  return (
    <div className="nx-sua-ds">
      {items.map((it, i) => (
        <div key={i} className="nx-sua-muc">
          {render(it, (k, v) => onChange(items.map((x, j) => (j === i ? { ...x, [k]: v } : x))))}
          <div className="hang-nut">
            <button type="button" className="text-button" disabled={i === 0} onClick={() => { const n = [...items]; [n[i - 1], n[i]] = [n[i], n[i - 1]]; onChange(n); }}>Lên</button>
            <button type="button" className="text-button danger" onClick={() => onChange(items.filter((_, j) => j !== i))}>Bỏ</button>
          </div>
        </div>
      ))}
      <button type="button" className="nut phu" onClick={() => onChange([...items, { ...mau }])}>{them}</button>
    </div>
  );
}

/** Xem trước một slide với chú thích, để người review biết câu trích có khớp chữ trên slide không. */
function XemSlide({ s, hinh, url }) {
  const diem = diemTrenSlide(s, hinh?.chu);
  if (!url) return null;
  const lech = diem.filter((d) => d.trich && !d.khung.length).length;
  return (
    <div className="nx-xem-slide">
      <SlideChuThich url={url} tiLe={hinh?.tiLe} diem={diem} chu={hinh?.chu} so={s.so} />
      {lech > 0 && <p className="story-loi">{lech} câu trích không tìm thấy trên slide nên không gạch chân được. Chép lại đúng từng chữ trên slide, hoặc để trống nếu nói về cả slide.</p>}
      {hinh && !hinh.chu?.length && <p className="nho">Slide này không có lớp chữ (xuất dạng ảnh), nên chỉ hiện ảnh, không gạch chân được.</p>}
    </div>
  );
}

function BienTap({ nx, setNx, hinh }) {
  const set = (k, v) => setNx((o) => ({ ...o, [k]: v }));
  const trang = hinh?.status === "xong" ? hinh.trang : null;
  const url = useAnhSlide(trang);
  const hinhTheoSo = new Map((trang || []).map((t) => [t.so, t]));
  return (
    <div className="story-form nx-bien-tap">
      <fieldset>
        <legend>Đánh giá chung</legend>
        <div className="o-nhap">
          <div><label>Điểm tổng (0 đến 100)</label><input type="number" min="0" max="100" value={nx.diemTong ?? ""} onChange={(e) => set("diemTong", e.target.value === "" ? null : Number(e.target.value))} /></div>
          <div><label>Mức sẵn sàng</label><select value={nx.mucDo} onChange={(e) => set("mucDo", e.target.value)}>{Object.entries(MUC_DO).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select></div>
        </div>
        <label>Tóm tắt</label>
        <textarea rows="4" value={nx.tomTat} onChange={(e) => set("tomTat", e.target.value)} />
        <label>Lời nhắn của bạn (góc nhìn cá nhân, hiện ngay dưới đánh giá chung)</label>
        <textarea rows="5" value={nx.loiNhan} placeholder="Điều bạn muốn nói riêng với founder này, từ kinh nghiệm của bạn." onChange={(e) => set("loiNhan", e.target.value)} />
      </fieldset>

      {nx.soVoiLanTruoc && (
        <fieldset>
          <legend>So với lượt trước</legend>
          <label>Nhận xét chung</label>
          <textarea rows="3" value={nx.soVoiLanTruoc.nhanXet} onChange={(e) => set("soVoiLanTruoc", { ...nx.soVoiLanTruoc, nhanXet: e.target.value })} />
          <SuaDanhSach items={nx.soVoiLanTruoc.viec} mau={{ viec: "", ketQua: "chua-sua", ghiChu: "" }} them="+ Thêm việc" onChange={(v) => set("soVoiLanTruoc", { ...nx.soVoiLanTruoc, viec: v })}
            render={(it, sv) => <div className="o-nhap">
              <div><label>Việc lượt trước</label><input type="text" value={it.viec} onChange={(e) => sv("viec", e.target.value)} /></div>
              <div><label>Kết quả</label><select value={it.ketQua} onChange={(e) => sv("ketQua", e.target.value)}>{Object.entries(KET_QUA_SUA).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select></div>
              <div><label>Ghi chú</label><input type="text" value={it.ghiChu} onChange={(e) => sv("ghiChu", e.target.value)} /></div>
            </div>} />
        </fieldset>
      )}

      <fieldset>
        <legend>Nhà đầu tư sẽ dừng lại ở đâu</legend>
        <SuaDanhSach items={nx.diemDung} mau={{ chuDe: "", lyDo: "", slide: "" }} them="+ Thêm điểm dừng" onChange={(v) => set("diemDung", v)}
          render={(it, s) => <>
            <div className="o-nhap">
              <div><label>Chủ đề</label><input type="text" value={it.chuDe} placeholder="Đội ngũ" onChange={(e) => s("chuDe", e.target.value)} /></div>
              <div><label>Slide</label><input type="text" value={it.slide} placeholder="18" onChange={(e) => s("slide", e.target.value)} /></div>
            </div>
            <textarea rows="2" value={it.lyDo} placeholder="Vì sao nhà đầu tư dừng ở đây" onChange={(e) => s("lyDo", e.target.value)} />
          </>} />
        <label>Điều khiến nhà đầu tư đọc tiếp (mỗi dòng một ý)</label>
        <textarea rows="3" value={dong(nx.diemManh)} onChange={(e) => set("diemManh", e.target.value.split("\n"))} />
      </fieldset>

      <fieldset>
        <legend>Việc nên sửa trước</legend>
        <SuaDanhSach items={nx.uuTien} mau={{ viec: "", viSao: "", muc: "cao", slide: "" }} them="+ Thêm việc" onChange={(v) => set("uuTien", v)}
          render={(it, s) => <>
            <div className="o-nhap">
              <div><label>Việc cần làm</label><input type="text" value={it.viec} onChange={(e) => s("viec", e.target.value)} /></div>
              <div><label>Mức</label><select value={it.muc} onChange={(e) => s("muc", e.target.value)}>{Object.entries(MUC_UU_TIEN).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select></div>
              <div><label>Slide</label><input type="text" value={it.slide} placeholder="14-15" onChange={(e) => s("slide", e.target.value)} /></div>
            </div>
            <textarea rows="2" value={it.viSao} placeholder="Vì sao, làm thế nào" onChange={(e) => s("viSao", e.target.value)} />
          </>} />
      </fieldset>

      <fieldset>
        <legend>Theo từng trục</legend>
        {nx.truc.map((t, i) => (
          <div key={t.ma} className="nx-sua-muc">
            <div className="o-nhap"><div><label>{t.ten}</label>
              <select value={t.diem ?? ""} onChange={(e) => set("truc", nx.truc.map((x, j) => (j === i ? { ...x, diem: e.target.value === "" ? null : Number(e.target.value) } : x)))}>
                <option value="">Không chấm</option>{[1, 2, 3, 4, 5].map((n) => <option key={n} value={n}>{n}/5</option>)}
              </select></div></div>
            <textarea rows="2" value={t.nhanXet} onChange={(e) => set("truc", nx.truc.map((x, j) => (j === i ? { ...x, nhanXet: e.target.value } : x)))} />
          </div>
        ))}
      </fieldset>

      <fieldset>
        <legend>Từng slide</legend>
        <SuaDanhSach items={nx.slides} mau={{ so: nx.slides.length + 1, tieuDe: "", danhGia: "can-sua", nhanXetNgan: "", diem: [], vanDe: [], goiY: [], hienTai: "", vietLai: "" }} them="+ Thêm slide"
          onChange={(v) => set("slides", v)}
          render={(it, s) => <>
            <div className="o-nhap">
              <div><label>Slide số</label><input type="number" min="1" value={it.so} onChange={(e) => s("so", Number(e.target.value))} /></div>
              <div><label>Tiêu đề</label><input type="text" value={it.tieuDe} onChange={(e) => s("tieuDe", e.target.value)} /></div>
              <div><label>Đánh giá</label><select value={it.danhGia} onChange={(e) => s("danhGia", e.target.value)}>{Object.entries(DANH_GIA_SLIDE).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select></div>
            </div>
            <label>Tóm tắt một câu (hiện khi slide đang thu gọn)</label><input type="text" value={it.nhanXetNgan} onChange={(e) => s("nhanXetNgan", e.target.value)} />
            <XemSlide s={it} hinh={hinhTheoSo.get(it.so)} url={url[it.so]} />
            <label>Chỗ cần sửa trên slide (mỗi chỗ có số và mũi tên trên ảnh)</label>
            <SuaDanhSach items={it.diem || []} mau={{ trich: "", viSao: "", suaGi: "", cachSua: "" }} them="+ Thêm chỗ cần sửa" onChange={(v) => s("diem", v)}
              render={(d, sd) => <>
                <label>Chữ trên slide (chép đúng từng chữ; để trống nếu nói về cả slide)</label><input type="text" value={d.trich} onChange={(e) => sd("trich", e.target.value)} />
                <label>Vì sao cần sửa</label><textarea rows="2" value={d.viSao} onChange={(e) => sd("viSao", e.target.value)} />
                <label>Sửa cái gì</label><input type="text" value={d.suaGi} onChange={(e) => sd("suaGi", e.target.value)} />
                <label>Sửa như thế nào</label><textarea rows="2" value={d.cachSua} onChange={(e) => sd("cachSua", e.target.value)} />
              </>} />
            <label>Nhận xét thêm (mỗi dòng một ý)</label><textarea rows="3" value={dong(it.vanDe)} onChange={(e) => s("vanDe", e.target.value.split("\n"))} />
            <label>Nên sửa (mỗi dòng một ý)</label><textarea rows="3" value={dong(it.goiY)} onChange={(e) => s("goiY", e.target.value.split("\n"))} />
            <label>Câu đang có trên slide (trước)</label><textarea rows="2" value={it.hienTai} onChange={(e) => s("hienTai", e.target.value)} />
            <label>Gợi ý viết lại (sau)</label><textarea rows="2" value={it.vietLai} onChange={(e) => s("vietLai", e.target.value)} />
          </>} />
      </fieldset>

      <fieldset>
        <legend>Deck còn thiếu</legend>
        <SuaDanhSach items={nx.thieu} mau={{ noiDung: "", viSao: "" }} them="+ Thêm mục thiếu" onChange={(v) => set("thieu", v)}
          render={(it, s) => <><input type="text" value={it.noiDung} placeholder="Thiếu gì" onChange={(e) => s("noiDung", e.target.value)} /><textarea rows="2" value={it.viSao} placeholder="Nhà đầu tư cần để làm gì" onChange={(e) => s("viSao", e.target.value)} /></>} />
      </fieldset>

      <fieldset>
        <legend>Checklist 10 slide</legend>
        {nx.checklist.length === 0
          ? <button type="button" className="nut phu" onClick={() => set("checklist", TIEU_CHI.map((t) => ({ ...t, ketQua: "chua", ghiChu: "" })))}>Thêm checklist</button>
          : nx.checklist.map((c, i) => (
            <div key={c.ma} className="o-nhap nx-ck-sua">
              <div><label>{c.ten}</label>
                <select value={c.ketQua} onChange={(e) => set("checklist", nx.checklist.map((x, j) => (j === i ? { ...x, ketQua: e.target.value } : x)))}>
                  {Object.entries(KET_QUA_TIEU_CHI).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                </select></div>
              <div><label>Ghi chú</label><input type="text" value={c.ghiChu} onChange={(e) => set("checklist", nx.checklist.map((x, j) => (j === i ? { ...x, ghiChu: e.target.value } : x)))} /></div>
            </div>
          ))}
      </fieldset>

      <fieldset>
        <legend>Câu hỏi nhà đầu tư sẽ hỏi (mỗi dòng một câu)</legend>
        <textarea rows="5" value={dong(nx.cauHoi)} onChange={(e) => set("cauHoi", e.target.value.split("\n"))} />
      </fieldset>

      <fieldset>
        <legend>Đọc thêm</legend>
        <SuaDanhSach items={nx.docThem} mau={{ path: "/playbook/", ten: "", lyDo: "" }} them="+ Thêm trang" onChange={(v) => set("docThem", v)}
          render={(it, s) => <div className="o-nhap">
            <div><label>Đường dẫn</label><input type="text" value={it.path} onChange={(e) => s("path", e.target.value)} /></div>
            <div><label>Tên hiển thị</label><input type="text" value={it.ten} onChange={(e) => s("ten", e.target.value)} /></div>
            <div><label>Lý do</label><input type="text" value={it.lyDo} onChange={(e) => s("lyDo", e.target.value)} /></div>
          </div>} />
      </fieldset>

      <fieldset>
        <legend>Ghi chú nội bộ (không gửi founder)</legend>
        <textarea rows="4" value={nx.ghiChuNoiBo} onChange={(e) => set("ghiChuNoiBo", e.target.value)} />
      </fieldset>
    </div>
  );
}

const NHAN_SO_LIEU = {
  postMoney: "Post-money", tyLeVongNay: "% nhà đầu tư nhận ở vòng này", burnNgamDinh: "Burn mỗi tháng (số gọi chia runway)",
  burnMoiNguoi: "Burn mỗi người mỗi tháng", loiNhuanNgamDinh: "Lợi nhuận exit tính lại", irr: "IRR ngầm định (%)",
  tangTruongDuPhong: "Tăng trưởng dự phóng mỗi năm (%)",
};

/**
 * Kết quả kiểm tra số liệu bằng code (functions: lượt trích xuất + shared/kiemTraDeck.js).
 * Không phát hiện nào tự tới tay founder: người review bấm đưa vào bản biên tập.
 */
function KiemTraSoLieu({ kt, nx, setNx }) {
  const [daThem, setDaThem] = useState({});
  if (!kt) return null;
  if (kt.trangThai !== "xong") {
    return <section className="surface nx-kt"><h3>Kiểm tra số liệu tự động</h3><p className="nho">Lần chạy này không kiểm tra được số liệu{kt.loi ? `: ${kt.loi}` : "."} Bản nháp AI vẫn dùng được như trước.</p></section>;
  }
  const ds = kt.phatHien || [];
  const danhDau = (ma, viec) => { setNx(viec); setDaThem((o) => ({ ...o, [ma]: true })); };
  const vaoUuTien = (x) => danhDau(x.ma, (o) => ({ ...o, uuTien: [...o.uuTien, {
    viec: x.tieuDe, viSao: [x.chiTiet, x.goiY].filter(Boolean).join(" "), muc: x.muc === "co-do" ? "cao" : "vua", slide: (x.slides || []).join(", "),
  }] }));
  const vaoSlide = (x) => danhDau(x.ma, (o) => {
    const so = Number(x.slides[0]);
    const co = o.slides.some((s) => s.so === so);
    const them = (s) => ({ ...s, diem: [...(s.diem || []), { trich: "", viSao: x.chiTiet, suaGi: x.tieuDe, cachSua: x.goiY || "" }] });
    const slides = co ? o.slides.map((s) => (s.so === so ? them(s) : s))
      : [...o.slides, them({ so, tieuDe: "", danhGia: "can-sua", nhanXetNgan: "", diem: [], vanDe: [], goiY: [], hienTai: "", vietLai: "" })].sort((a, b) => a.so - b.so);
    return { ...o, slides };
  });
  const vaoThieu = (x) => danhDau(x.ma, (o) => ({ ...o, thieu: [...o.thieu, { noiDung: x.tieuDe.replace(/^Thiếu:\s*/, ""), viSao: x.chiTiet }] }));
  const nhom = Object.keys(MUC_PHAT_HIEN).map((m) => [m, ds.filter((x) => x.muc === m)]).filter(([, a]) => a.length);
  const soLieu = Object.entries(kt.soLieu || {}).filter(([k]) => NHAN_SO_LIEU[k]);

  return (
    <section className="surface nx-kt">
      <h3>Kiểm tra số liệu tự động <span className="pill">{ds.length} phát hiện</span></h3>
      <p className="nho">Code đọc số liệu AI trích từ deck rồi kiểm toán học và đối chiếu giữa các slide, nên các phát hiện này chính xác theo số trên deck. AI nhận xét đã được xem trước danh sách này. Bấm để đưa phát hiện vào bản biên tập; không có gì tự gửi founder.</p>
      {kt.biHa?.length > 0 && <p className="nx-kt-ha">Điểm trục bị hạ do lỗi số liệu: {kt.biHa.map((b) => `${b.ten} từ ${b.tu} xuống ${b.con}/5`).join(", ")}.</p>}
      {soLieu.length > 0 && (
        <dl className="nx-kt-so">
          {soLieu.map(([k, v]) => <div key={k}><dt>{NHAN_SO_LIEU[k]}</dt><dd>{Array.isArray(v) ? v.join(" đến ") : v.toLocaleString("vi-VN")}</dd></div>)}
        </dl>
      )}
      {ds.length === 0 && <p>Không thấy lỗi số liệu nào. Deck có thể ít số, hoặc số đã khớp nhau.</p>}
      {nhom.map(([m, a]) => (
        <div key={m} className={`nx-kt-nhom nx-kt-${m}`}>
          <h4>{MUC_PHAT_HIEN[m]} ({a.length})</h4>
          <ul>
            {a.map((x) => (
              <li key={x.ma}>
                <strong>{x.tieuDe}</strong>{x.slides?.length > 0 && <span className="nho"> (slide {x.slides.join(", ")})</span>}
                <p>{x.chiTiet}</p>
                {x.bangChung?.length > 0 && <p className="nho">{x.bangChung.join("; ")}</p>}
                {x.goiY && <p className="nho"><em>Gợi ý: {x.goiY}</em></p>}
                <div className="hang-nut">
                  {daThem[x.ma] ? <span className="nho">Đã đưa vào bản biên tập</span> : <>
                    <button type="button" className="text-button" onClick={() => vaoUuTien(x)}>Đưa vào việc nên sửa</button>
                    {x.slides?.length > 0 && <button type="button" className="text-button" onClick={() => vaoSlide(x)}>Đưa vào slide {x.slides[0]}</button>}
                    {x.ma.startsWith("thieu.") && <button type="button" className="text-button" onClick={() => vaoThieu(x)}>Đưa vào deck còn thiếu</button>}
                  </>}
                </div>
              </li>
            ))}
          </ul>
        </div>
      ))}
      {kt.trichXuat && <details><summary>Số liệu AI trích xuất (để kiểm lại khi nghi ngờ)</summary><pre className="nx-tho">{JSON.stringify(kt.trichXuat, null, 2)}</pre></details>}
    </section>
  );
}

const NHAN_HINH = { requested: "Đang xếp hàng", running: "Đang dựng hình", xong: "Đã có hình", loi: "Lỗi", cho: "Đang xếp hàng" };

function ChiTiet({ yc, onDoi, ds = [] }) {
  const [ai, setAi] = useState(null);
  const [hinh, setHinh] = useState(null);
  const henHinh = useRef(null);
  const [nx, setNx] = useState(TRONG);
  const [daNap, setDaNap] = useState(false);
  const [chiDan, setChiDan] = useState("");
  const [msg, setMsg] = useState("");
  const [xemTruoc, setXemTruoc] = useState(false);
  const [pdf, setPdf] = useState("");
  const [lyDo, setLyDo] = useState("");
  const [ban, setBan] = useState(false);
  const hen = useRef(null);

  async function napAI(ghiDeBanBienTap) {
    const a = await docBanNhapAI(yc.id).catch(() => null);
    setAi(a);
    if (ghiDeBanBienTap) {
      // Ưu tiên: kết quả đã gửi, rồi bản đang biên tập, rồi bản nháp AI.
      const goc = yc.status === "da_gui" && !a?.banBienTap ? yc.ketQua : (a?.banBienTap || a?.nhap);
      setNx(goc ? chuanHoaNhanXet(goc) : TRONG);
      setDaNap(Boolean(goc));
    }
    return a;
  }
  useEffect(() => {
    setXemTruoc(false); setMsg(""); setPdf(""); setDaNap(false);
    napAI(true);
    docHinh(yc.id).then(setHinh).catch(() => setHinh(null));
    if (yc.deckPath) linkXemDeck(yc.deckPath).then(setPdf).catch(() => setPdf(""));
    return () => clearTimeout(hen.current);
  }, [yc.id]);
  // Hỏi lại mỗi 8 giây khi AI đang chạy (firestore/lite không theo dõi thời gian thực).
  useEffect(() => {
    clearTimeout(hen.current);
    if (ai && ["requested", "running"].includes(ai.status)) {
      hen.current = setTimeout(async () => {
        const a = await napAI(false);
        if (a?.status === "xong" && !daNap) { setNx(chuanHoaNhanXet(a.banBienTap || a.nhap)); setDaNap(true); setMsg("Bản nháp AI vừa xong."); }
      }, 8000);
    }
    return () => clearTimeout(hen.current);
  }, [ai]);

  useEffect(() => {
    clearTimeout(henHinh.current);
    if (hinh && ["requested", "running", "cho"].includes(hinh.status)) {
      henHinh.current = setTimeout(() => docHinh(yc.id).then(setHinh).catch(() => {}), 5000);
    }
    return () => clearTimeout(henHinh.current);
  }, [hinh]);
  const dungHinh = () => lam(async () => { await yeuCauDungHinh(yc.id); setHinh(await docHinh(yc.id)); }, "Đang dựng hình từng slide, thường mất dưới một phút.");
  const luot = cacLuot(ds, yc.id);
  const truoc = luotTruocCoKetQua(ds, yc.id);
  const linkLuot = (id) => `/admin/nhan-xet-deck?xem=${id}`;

  // Xếp hàng quá 5 phút mà chưa chạy nghĩa là lượt kích hoạt đã bị lỡ (ví dụ
  // trigger chưa sẵn sàng): cho bấm chạy lại thay vì kẹt mãi.
  const ket = ai?.status === "requested" && ai?.yeuCauLuc && Date.now() - ai.yeuCauLuc.getTime() > 5 * 60 * 1000;
  const dangChay = ["requested", "running"].includes(ai?.status) && !ket;

  async function lam(viec, thongBao) {
    setBan(true); setMsg("");
    try { await viec(); setMsg(thongBao); } catch (e) { setMsg(e.message); } finally { setBan(false); }
  }
  const chayAI = () => lam(async () => { await yeuCauChayAI(yc.id, chiDan); await napAI(false); }, "Đã gửi yêu cầu. AI thường mất 2 đến 5 phút.");
  const napLaiNhap = () => { if (ai?.nhap) { setNx(chuanHoaNhanXet(ai.nhap)); setMsg("Đã nạp bản nháp AI mới nhất vào khung biên tập (chưa lưu)."); } };
  const luu = () => lam(() => luuBanBienTap(yc.id, nx), "Đã lưu bản biên tập.");
  const gui = () => {
    if (!window.confirm(`Gửi nhận xét cho ${yc.email}? Founder sẽ nhận email và xem được ngay.`)) return;
    lam(async () => { await guiKetQua(yc.id, nx, hinh); onDoi(); }, hinh?.status === "xong" ? "Đã gửi cho founder, kèm hình từng slide." : "Đã gửi cho founder (chưa có hình slide).");
  };
  const tuChoi = () => lam(async () => { await datTrangThai(yc.id, "tu_choi", { lyDoTuChoi: lyDo.trim() }); onDoi(); }, "Đã báo founder.");

  return (
    <div className="nx-admin-chi-tiet">
      <header>
        <h2>{yc.congTy} <span className="pill">{TRANG_THAI[yc.status]?.nhan}</span></h2>
        <p className="nho">{yc.email}, gửi {ngayGio(yc.createdAt)}. {yc.nganh || "Chưa ghi ngành"}, {yc.giaiDoan}, vòng {yc.vong}, gọi {yc.soVon || "chưa ghi"}.</p>
        {yc.canGopY && <p><strong>Founder muốn góp ý:</strong> {yc.canGopY}</p>}
        {yc.tuDong && <p className="nho">AI đã tự gửi bản này cho founder lúc {ngayGio(yc.guiLuc)}. Sửa bên dưới rồi bấm "Gửi lại bản đã sửa" nếu cần.</p>}
        <p className="hang-nut">
          {pdf ? <a className="nut phu" href={pdf} target="_blank" rel="noreferrer">Mở deck ({yc.deckMB} MB)</a> : <span className="nho">{yc.deckDaXoa ? "Tệp deck đã tự xoá." : "Đang lấy tệp deck…"}</span>}
          <Link className="text-button" to={`/nhan-xet-deck?xem=${yc.id}`}>Trang founder thấy</Link>
        </p>
      </header>

      {luot.length > 1 && (
        <p className="nho">Lượt {luot.find((y) => y.id === yc.id)?.luot} của deck này. {luot.filter((y) => y.id !== yc.id).map((y) => <Link key={y.id} className="text-button" to={linkLuot(y.id)}>Lượt {y.luot}{y.ketQua?.diemTong != null ? ` (${y.ketQua.diemTong})` : ""}</Link>)}{truoc ? " AI đã được xem tóm tắt lượt trước để chấm việc nào đã sửa." : ""}</p>
      )}

      <section className="surface nx-ai">
        <h3>Hình từng slide {hinh && <span className="pill">{NHAN_HINH[hinh.status] || hinh.status}</span>}</h3>
        <p className="nho">
          {hinh?.status === "xong"
            ? `${hinh.trang?.length || 0} slide có ảnh, ${hinh.coChu ?? 0} slide có lớp chữ để gạch chân. Hình được gửi cho founder cùng nhận xét.`
            : "Ảnh từng slide để báo cáo chỉ đúng chỗ cần sửa. Deck gửi trước khi có tính năng này cần bấm tạo hình."}
        </p>
        {hinh?.loi && <p className="story-loi">{hinh.loi}</p>}
        <button type="button" className="nut phu" disabled={ban || yc.deckDaXoa || ["requested", "running"].includes(hinh?.status)} onClick={dungHinh}>{hinh?.status === "xong" ? "Tạo lại hình" : "Tạo hình slide"}</button>
        {yc.status === "da_gui" && hinh?.status === "xong" && !yc.hinhSlide && <p className="nho">Founder chưa thấy hình: bấm "Gửi lại bản đã sửa" bên dưới để gửi kèm.</p>}
      </section>

      <section className="surface nx-ai">
        <h3>Bản nháp AI {ai && <span className="pill">{NHAN_AI[ai.status] || ai.status}</span>}</h3>
        {ai?.lyDo && <p className="nho">{ai.lyDo}</p>}
        {ket && <p className="nho">Yêu cầu đã xếp hàng hơn 5 phút mà AI chưa nhận. Bấm "Chạy AI" để thử lại; nếu vẫn vậy, xem Logs của chayNhanXetAI trong Firebase Console.</p>}
        {ai?.loi && <p className="story-loi">{ai.loi}</p>}
        {ai?.xongLuc && ai?.token && <p className="nho">Lần chạy gần nhất: {ngayGio(ai.xongLuc)}, {ai.model}, {ai.token?.vao?.toLocaleString("vi-VN")} token vào, {ai.token?.ra?.toLocaleString("vi-VN")} token ra, khoảng {ai.chiPhiUSD} USD.{ai.stopReason === "max_tokens" ? " Câu trả lời bị cắt vì quá dài." : ""}</p>}
        {ai?.banTho && <details><summary>Bản thô AI trả về</summary><pre className="nx-tho">{ai.banTho}</pre></details>}
        <label htmlFor="nx-chi-dan">Chỉ dẫn thêm cho lần chạy này (không bắt buộc)</label>
        <textarea id="nx-chi-dan" rows="2" value={chiDan} placeholder="Ví dụ: soi kỹ slide tài chính và số vốn gọi; founder là người lần đầu làm deck." onChange={(e) => setChiDan(e.target.value)} />
        <div className="hang-nut">
          <button type="button" className="nut phu" disabled={ban || dangChay || yc.deckDaXoa} onClick={chayAI}>{ai?.nhap ? "Chạy lại AI" : "Chạy AI"}</button>
          {ai?.nhap && daNap && <button type="button" className="text-button" onClick={napLaiNhap}>Nạp lại bản nháp AI vào khung biên tập</button>}
        </div>
      </section>

      {!xemTruoc && <KiemTraSoLieu kt={ai?.kiemTra} nx={nx} setNx={setNx} />}

      <div className="hang-nut nx-che-do">
        <button type="button" className={xemTruoc ? "nut phu" : "nut"} onClick={() => setXemTruoc(false)}>Biên tập</button>
        <button type="button" className={xemTruoc ? "nut" : "nut phu"} onClick={() => setXemTruoc(true)}>Xem như founder</button>
      </div>
      {xemTruoc
        ? <KetQuaNhanXet nx={banChoFounder(nx)} yc={yc} hinh={hinh?.status === "xong" ? hinh.trang : null} cacLuot={luot} truoc={truoc} linkLuot={linkLuot} />
        : <BienTap nx={nx} setNx={setNx} hinh={hinh} />}

      {msg && <p className="nho" role="status">{msg}</p>}
      <div className="hang-nut nx-hanh-dong">
        <button type="button" className="nut phu" disabled={ban} onClick={luu}>Lưu bản biên tập</button>
        <button type="button" className="nut" disabled={ban || !nx.tomTat} onClick={gui}>{yc.status === "da_gui" ? "Gửi lại bản đã sửa" : "Gửi cho founder"}</button>
      </div>
      {yc.status !== "da_gui" && (
        <details className="nx-tu-choi">
          <summary>Không nhận xét deck này…</summary>
          <label htmlFor="nx-ly-do">Lý do gửi founder</label>
          <textarea id="nx-ly-do" rows="2" value={lyDo} placeholder="Ví dụ: tệp không phải pitch deck, hoặc PDF bị khoá mật khẩu." onChange={(e) => setLyDo(e.target.value)} />
          <button type="button" className="nut nut-nguy-hiem" disabled={ban || !lyDo.trim()} onClick={tuChoi}>Báo founder</button>
        </details>
      )}
    </div>
  );
}

function GocNhin() {
  const [v, setV] = useState("");
  const [msg, setMsg] = useState("");
  useEffect(() => { docGocNhin().then(setV).catch(() => {}); }, []);
  return (
    <details className="surface nx-goc-nhin">
      <summary>Góc nhìn riêng của bạn cho AI</summary>
      <p className="nho">AI đọc phần này ở mọi lần nhận xét và ưu tiên nó hơn hướng dẫn chung của website. Ghi những điều bạn luôn nhắc founder, những lỗi bạn hay gặp, cách bạn muốn giọng văn nghe như thế nào.</p>
      <textarea rows="10" value={v} onChange={(e) => setV(e.target.value)} />
      <div className="hang-nut">
        <button type="button" className="nut phu" onClick={() => luuGocNhin(v).then(() => setMsg("Đã lưu. Áp dụng từ lần chạy AI tiếp theo.")).catch((e) => setMsg(e.message))}>Lưu góc nhìn</button>
        {msg && <span className="nho">{msg}</span>}
      </div>
    </details>
  );
}

export default function NhanXetDeckAdmin() {
  const [user, setUser] = useState(null);
  const [allowed, setAllowed] = useState(false);
  const [checking, setChecking] = useState(true);
  const [ds, setDs] = useState([]);
  const [loc, setLoc] = useState("can-lam");
  const [params, setParams] = useSearchParams();
  const xem = params.get("xem");
  const [msg, setMsg] = useState("");

  useEffect(() => theoDoiDangNhap(async (next) => {
    setUser(next); setAllowed(false); setChecking(true);
    if (next) try {
      const db = await layDb(); const { doc, getDoc } = await import("firebase/firestore/lite");
      const snap = await getDoc(doc(db, "admins", next.uid));
      setAllowed(["admin", "editor"].includes(snap.exists() ? snap.data()?.role : ""));
    } catch { setAllowed(false); }
    setChecking(false);
  }), []);
  const napDs = () => docTatCaYeuCau().then(setDs).catch((e) => setMsg(e.message));
  useEffect(() => { if (allowed) napDs(); }, [allowed]);

  if (checking) return <p>Đang kiểm tra quyền…</p>;
  if (!user) return <section className="surface"><h1>Nhận xét pitch deck</h1><p>Đăng nhập bằng tài khoản quản trị.</p><button type="button" className="nut" onClick={() => dangNhapGoogle().catch((e) => setMsg(e.message))}>Đăng nhập với Google</button>{msg && <p>{msg}</p>}</section>;
  if (!allowed) return <section className="surface"><h1>Nhận xét pitch deck</h1><p>Tài khoản {user.email} chưa có quyền quản trị.</p></section>;

  const yc = ds.find((y) => y.id === xem);
  return (
    <div className="nx-admin">
      <header className="page-heading">
        <p className="eyebrow">Quản trị</p>
        <h1>Nhận xét pitch deck</h1>
      </header>
      <GocNhin />
      {msg && <p className="story-loi">{msg}</p>}
      <div className="admin-layout">
        <DanhSach ds={ds} dangChon={xem} onChon={(id) => setParams({ xem: id })} loc={loc} setLoc={setLoc} />
        {yc ? <ChiTiet key={yc.id} yc={yc} ds={ds} onDoi={napDs} /> : <section className="surface"><p>{ds.length ? "Chọn một deck ở danh sách bên trái." : "Chưa có deck nào."}</p></section>}
      </div>
    </div>
  );
}
